module.exports = __webpack_public_path__ + "media/images/brand/img-arrow-e4e65733333826945e3c3fc3875250a1.svg";